import { render } from "./SurverySummary.vue?vue&type=template&id=6c7294f0&ts=true"
import script from "./SurverySummary.vue?vue&type=script&lang=ts"
export * from "./SurverySummary.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__